var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "更新其他信息",
        visible: _vm.dialogVisible,
        width: "690px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, "label-position": "top" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "注册时间", prop: "registerDate" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              align: "center",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.form.registerDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "registerDate", $$v)
                              },
                              expression: "form.registerDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "生效日期", prop: "effectiveDate" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              align: "center",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.form.effectiveDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "effectiveDate", $$v)
                              },
                              expression: "form.effectiveDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "截止时间", prop: "closeDate" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              align: "center",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.form.closeDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "closeDate", $$v)
                              },
                              expression: "form.closeDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "报税截止时间",
                            prop: "bondedDeadlineDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              align: "center",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.form.bondedDeadlineDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bondedDeadlineDate", $$v)
                              },
                              expression: "form.bondedDeadlineDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "年审截止时间",
                            prop: "yearAuditDeadlineDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              align: "center",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.form.yearAuditDeadlineDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "yearAuditDeadlineDate", $$v)
                              },
                              expression: "form.yearAuditDeadlineDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "BOI是否", prop: "isBOI" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.form.isBOI,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isBOI", $$v)
                                },
                                expression: "form.isBOI",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: true },
                              }),
                              _c("el-option", {
                                attrs: { label: "否", value: false },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "月结是否", prop: "isMonthEnd" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.form.isMonthEnd,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isMonthEnd", $$v)
                                },
                                expression: "form.isMonthEnd",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: true },
                              }),
                              _c("el-option", {
                                attrs: { label: "否", value: false },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否敏感进口商",
                            prop: "isSensitiveImporter",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              model: {
                                value: _vm.form.isSensitiveImporter,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isSensitiveImporter", $$v)
                                },
                                expression: "form.isSensitiveImporter",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: true },
                              }),
                              _c("el-option", {
                                attrs: { label: "否", value: false },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否注销", prop: "isCancel" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: {
                                change: function ($event) {
                                  _vm.form.cancelDate = null
                                },
                              },
                              model: {
                                value: _vm.form.isCancel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isCancel", $$v)
                                },
                                expression: "form.isCancel",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: true },
                              }),
                              _c("el-option", {
                                attrs: { label: "否", value: false },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _vm.form.isCancel
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "注销时间", prop: "cancelDate" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  align: "center",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.cancelDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cancelDate", $$v)
                                  },
                                  expression: "form.cancelDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否禁用", prop: "isActived" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": _vm.form.isActived ? "是" : "否",
                            },
                            model: {
                              value: _vm.form.isActived,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isActived", $$v)
                              },
                              expression: "form.isActived",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "footers flex_c_c",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: { value: _vm.ok, args: ["form"] },
                  expression: "{ value: ok, args: ['form'] }",
                },
              ],
              staticClass: "ok flex_c_c",
            },
            [_vm._v(" 确定 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }